import { Box } from './box';
import { Chip } from './chip';
import { Typography } from './typography';

type Props = Readonly<{
  title: string;
  description?: string;
  count?: number;
  countLabel?: string;
}>;

export const PageHeader = ({ title, description, count, countLabel }: Props) => {
  return (
    <Box mb={3}>
      <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
        <Box>
          <Typography variant='h4' component='h1' gutterBottom>
            {title}
          </Typography>
          {description && (
            <Typography variant='body1' color='text.secondary'>
              {description}
            </Typography>
          )}
        </Box>
        {count !== undefined && countLabel && (
          <Chip label={`${count} ${countLabel}`} color='primary' size='medium' />
        )}
      </Box>
    </Box>
  );
};
